import type { FC } from "react";
import { useContext, useEffect } from "react";

import { ClientContext } from "~/contexts/client-context/provider";

type AnjouanGlobal = {
  init?: () => void;
};
/**
 * Компонент для инициализации Anjouan Gaming License Seal.
 * Он вызывает метод `init()` у глобального объекта,
 * добавленного внешним скриптом лицензии.
 */
export const AnjouanLicense: FC = () => {
  const clientContext = useContext(ClientContext);
  const anjouanLicensingData = clientContext?.anjouanLicensingData;

  const { window_execute_id, element_id, script_url } =
    anjouanLicensingData ?? {};
  useEffect(() => {
    if (!window_execute_id || !element_id || !script_url) {
      return;
    }
    if (typeof window !== "undefined") {
      // проверка на существование элемента с указанным id в DOM для избежания ошибок
      const el = document.getElementById(element_id);

      if (!el) return;

      const globalObject = window[window_execute_id] as AnjouanGlobal;
      globalObject?.init?.();
    }
  }, [window_execute_id, element_id]);

  return null;
};
